import ClassroomClashesDrawer from "./ClassroomClashesDrawer";

export default ClassroomClashesDrawer;
